import { createMultipartUploadQuery } from '../queries';
import makeRequest from '../../../../common/utils/makeRequest';

async function createS3MultipartUpload(apiClient,
bucketKey,
fileType,
organisationId) {
  const requestParams = {
    query: createMultipartUploadQuery,
    variables: { bucketKey, fileType, organisationId },
    context: { module: 'upload' },
    fetchPolicy: 'network-only'
  };
  const { data, error } = await makeRequest({
    request: apiClient.query,
    requestParams
  });

  if (!data || !data.createMultipartUpload || error) {return null;}

  return data.createMultipartUpload;
}

export default createS3MultipartUpload;